import { render } from "./Info4.vue?vue&type=template&id=2d213bec&scoped=true"
import script from "./Info4.vue?vue&type=script&lang=js"
export * from "./Info4.vue?vue&type=script&lang=js"

import "./Info4.vue?vue&type=style&index=0&id=2d213bec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d213bec"]])

export default __exports__